module.exports = "https://www.gc-pro.gnp.com.mx/336a66b264b1db0b929a9f22a17df512.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-info-poliza.svg
// module id = 1830
// module chunks = 0